module.exports = __webpack_public_path__ + "static/media/appstore@3x.d0279e1e.png";